import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';

import { useCurrentShift, useShiftControls } from '@/lib/shift/shift-controller';
import { CountdownTimer, Timer } from '../time/countdown-timer';
import { formatDuration, usePeriod } from '@/lib/time';
import { cn } from '@/lib/utils';
import { createKeyHandler } from '@/lib/keyboard';
import { differenceInSeconds } from 'date-fns';

export function WellnessCheck() {
  const shift = useCurrentShift();
  const controls = useShiftControls();
  // We don't need to use searchParams for this component
  const now = usePeriod(() => new Date(), 1000);
  const isAlmostBreaching = differenceInSeconds(shift.idleAt, now) <= 60;
  const hasShift = shift.shift != null;

  const handleEndShift = async () => {
    controls.endShift({ clean: true });
  };

  const handleStillHere = async () => {
    console.debug('Still here from wellness check.');
    controls.ack();
  };

  const onWellnessKeydown = createKeyHandler({
    enter: () => {
      handleEndShift();
    },
    escape: () => {
      handleStillHere();
    },
  });

  return (
    <>
      <Dialog open={hasShift && shift.status === 'inactive'}>
        <DialogContent
          showCloseButton={false}
          onOpenAutoFocus={(e) => e.preventDefault()}
          onKeyDown={onWellnessKeydown}
        >
          <DialogHeader className="flex flex-row items-center justify-between">
            <DialogTitle>Wellness Check</DialogTitle>
          </DialogHeader>
          <DialogDescription className="text-lg">
            Are you still there? Please respond to let the system know you are still here.
          </DialogDescription>

          <div className="w-full px-6">
            <>
              <div
                className={cn('mb-4 bg-muted/10 p-4 text-center text-2xl font-bold text-lime', {
                  'text-yellow-500': isAlmostBreaching,
                })}
              >
                <CountdownTimer time={shift.idleAt} format={(ms) => formatDuration(ms, 'short')} />
              </div>
            </>
          </div>

          <DialogFooter className="flex flex-col gap-4">
            <Button
              onClick={handleStillHere}
              className="w-full animate-pulse sm:w-auto"
              hotkey={{ keyboard: 'escape', controller: 'x' }}
              style={{ animationDuration: '2000ms' }}
            >
              I'm still here
            </Button>
            <Button
              onClick={handleEndShift}
              variant="outline"
              className="w-full sm:w-auto"
              hotkey={{ keyboard: 'enter', controller: 'a' }}
            >
              End Shift
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
